class PestsComponent extends HTMLElement {
  constructor() {
    super();
    this.init();
  }

  init() {
    this.buttons = this.querySelectorAll('[data-button]');
    this.items = this.querySelectorAll('[data-item]');
    this.setupEventListeners();
  }

  setupEventListeners() {
    this.buttons.forEach(button => {
      button.addEventListener('click', () => {
        let filterValue = button.getAttribute('data-button');
        this.handleFilterClick(filterValue, button);
      });
    });
  }

  handleFilterClick(filterValue, clickedButton) {
    this.updateActiveButton(clickedButton);
    this.filterItems(filterValue);
  }

  updateActiveButton(clickedButton) {
    this.buttons.forEach(btn => btn.removeAttribute('data-active'));
    clickedButton.setAttribute('data-active', '');
  }

  filterItems(filterValue) {
    this.items.forEach(item => {
      let itemValue = item.getAttribute('data-item');
      let shouldShow = this.shouldShowItem(itemValue, filterValue);
      this.toggleItemVisibility(item, shouldShow);
    });
  }

  shouldShowItem(itemValue, filterValue) {
    if (filterValue.toLowerCase() === 'show all') {
      return true;
    }
    return itemValue.split(',').some(v => v.trim() === filterValue);
  }

  toggleItemVisibility(item, show) {
    item.style.display = show ? '' : 'none';
  }
}

customElements.define('pests-component', PestsComponent);
